import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PostProspectResponse } from '../../Models/Models/Customer/PostProspectResponse';
import { CustomerCompliance } from '../../Models/Domains/Regulations/CustomerCompliance';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerRegulationComplianceClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(model: CustomerCompliance): Promise<PostProspectResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Regulations/CustomerRegulationCompliance/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<PostProspectResponse, any>(url, data);
  }
  public put(model: CustomerCompliance): Promise<PostProspectResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Regulations/CustomerRegulationCompliance/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.put<PostProspectResponse, any>(url, data);
  }
  public get(customerId: number): Promise<Array<CustomerCompliance>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Regulations/CustomerRegulationCompliance/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<CustomerCompliance>, any>(url, data);
  }
}

